export default {
  title: 'TIGHT ROUTE SETTINGS',
  items: {
    TightRouteSecPerMile: {
      label: 'Tight Route Seconds Per Mile',
      type: 'integer',
      unit: 'seconds'
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/tight-route.js